import { render } from "./GlobalSystemStatus.vue?vue&type=template&id=fac628e6"
import script from "./GlobalSystemStatus.vue?vue&type=script&lang=js"
export * from "./GlobalSystemStatus.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__